(() => {
  const selector = '[data-niuyu-pdp][data-niuyu-immersive]';

  function init() {
    const product = document.querySelector(selector);
    if (!product || product.niuyuImmersiveCleanup) return;
    let next = null;
    let sib = product.closest('.shopify-section')?.nextElementSibling;
    while (sib && !next) {
      next = sib.querySelector('.niuyu-cro-content--ingredients, [data-niuyu-immersive-next]');
      if (!next && sib.offsetHeight > 4) break;
      sib = sib.nextElementSibling;
    }
    const main = product.closest('main');
    if (!next || !main) return;

    const styles = getComputedStyle(product);
    const rgb = name => styles.getPropertyValue(name).trim().slice(1)
      .match(/.{2}/g).map(value => parseInt(value, 16));
    const start = rgb('--niuyu-immersive-start');
    const end = rgb('--niuyu-immersive-end');
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    const events = new AbortController();
    const options = { passive: true, signal: events.signal };
    let frame = 0;
    let previousColor = '';

    function render() {
      frame = 0;
      if (motion.matches) {
        next.removeAttribute('data-niuyu-immersive-transition');
        main.style.removeProperty('--niuyu-immersive-background');
        previousColor = '';
        return;
      }

      // Both sections fade together as their boundary moves through the viewport.
      const height = window.innerHeight;
      const bottom = product.getBoundingClientRect().bottom;
      const progress = Math.max(0, Math.min(1, (height * 0.9 - bottom) / (height * 0.7)));
      const eased = progress * progress * (3 - 2 * progress);
      const color = `rgb(${start.map((channel, index) =>
        Math.round(channel + (end[index] - channel) * eased)).join(', ')})`;
      next.setAttribute('data-niuyu-immersive-transition', '');
      if (color !== previousColor) {
        main.style.setProperty('--niuyu-immersive-background', color);
        previousColor = color;
      }
    }

    function schedule() {
      if (!frame) frame = requestAnimationFrame(render);
    }

    window.addEventListener('scroll', schedule, options);
    window.addEventListener('resize', schedule, options);
    window.addEventListener('pageshow', schedule, options);
    motion.addEventListener('change', schedule, options);
    const observer = new ResizeObserver(schedule);
    observer.observe(product);
    product.niuyuImmersiveCleanup = () => {
      events.abort();
      observer.disconnect();
      cancelAnimationFrame(frame);
      next.removeAttribute('data-niuyu-immersive-transition');
      main.style.removeProperty('--niuyu-immersive-background');
      delete product.niuyuImmersiveCleanup;
    };
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(product)) product.niuyuImmersiveCleanup();
    }, options);
    render();
  }

  init();
  document.addEventListener('shopify:section:load', init);
})();

/* Óvalo: a todo color solo en la primera foto; en el resto de la galería se calma para no competir con las infografías */
(function () {
  function bind() {
    document.querySelectorAll('.niuyu-pdp-main[data-niuyu-immersive]').forEach(function (root) {
      var counter = root.querySelector('[data-niuyu-counter-current]');
      if (!counter || counter.__niuAlt) return;
      counter.__niuAlt = true;
      var update = function () { root.classList.toggle('is-niu-altmedia', String(counter.textContent).trim() !== '1'); };
      new MutationObserver(update).observe(counter, { childList: true, characterData: true, subtree: true });
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind); else bind();
})();
